import styled, { CSSProperties } from 'styled-components';
import { SlideModalSmoother } from '../../../abstract/modal/slide/SlideModalSmoother';
import { Button, ButtonColorType } from '../../buttons/Button';

export interface ISlideConfirmModalButton {
  text?: string;
  color?: ButtonColorType;
  handleClick: () => void;
  isDisabled?: boolean;
}

interface SlideConfirmModalProps {
  isShow: boolean;
  height?: number;
  description?: string;
  confirmButton?: ISlideConfirmModalButton;
  closeButton: ISlideConfirmModalButton;
  element?: JSX.Element;
  isShowCloseButton?: boolean;
  gap?: string;
  padding?: string;
}

export const SlideConfirmModal = ({
  isShow,
  height,
  description,
  confirmButton,
  closeButton,
  element,
  isShowCloseButton = false,
  gap,
  padding,
}: SlideConfirmModalProps) => {
  return (
    <SlideModalSmoother
      targetState={isShow}
      openDelayTime={0}
      height={height ? `${height}px` : 'auto'}
      isShowCloseButton={isShowCloseButton}
      handleCloseButtonClick={closeButton && closeButton.handleClick}
      padding={padding}
      gap={gap}
    >
      <Container>
        {description && <Description>{description}</Description>}

        {element && <BodyContaier>{element}</BodyContaier>}

        {(confirmButton || closeButton.text) && (
          <ButtonContainer>
            {confirmButton && (
              <Button
                size={'md'}
                isDisabled={confirmButton.isDisabled}
                borderType={'square'}
                color={confirmButton.color ? confirmButton.color : 'filledPrimaryStrong'}
                text={{ size: 'md', content: confirmButton.text || '확인' }}
                onClick={confirmButton.handleClick}
              />
            )}

            {closeButton.text && (
              <Button
                size={'md'}
                borderType={'square'}
                color={'filledGreyLight'}
                text={{ size: 'md', content: closeButton.text }}
                onClick={closeButton.handleClick}
              />
            )}
          </ButtonContainer>
        )}
      </Container>
    </SlideModalSmoother>
  );
};

const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 24px;
`;

const Description = styled.pre`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
`;

const BodyContaier = styled.div`
  width: 100%;

  gap: 24px;
`;

const ButtonContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 8px;
`;
